<template>
  <div>
    <pin-yin-match-select :data="data" :is-multiple="true"
                          :model-value.sync="dataValue"
                          :placeholder="placeholder"
                          @change="onSubmit" @focus="getData"/>
  </div>
</template>

<script>
import {getOptionListByField} from "@/api/option";

export default {
  name: "PlatformSelect",
  props: {
    dataValue: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      data: [],
      placeholder: '请选择平台'
    }
  },
  methods: {
    onSubmit(val) {
      this.$emit('change', val)
    },
    getData() {
      if (this.data.length === 0) {
        //请求平台数据
        getOptionListByField({field: 'platforms'}).then(res => {
          let platforms = res.model.list
          if (platforms) {
            platforms.forEach((item) => {
              this.data.push({label: item.label + '(' + item.value + ')', value: item.label})
            })
          }

        })
      }
    }
  }
}
</script>

<style scoped>

</style>
